export default "__VITE_ASSET__BMBtWkPV__"